import { BREAKPOINT_MEDIUM, BREAKPOINT_SMALL } from '@big-red-group/storefront-common-ui'
import styled, { css, keyframes } from 'styled-components'
import { Wrapper as OptionSelectorWrapper } from '@/components/OptionSelector.styles'

export const Wrapper = styled.div`
  display: flex;

  @media (max-width: 1020px) {
    flex-direction: column;
  }
`
export const Image = styled.div`
  background-position: center center;
  background-size: cover;
  width: 144px;
  height: 116px;
  flex-shrink: 0;
  margin-right: 16px;

  @media (max-width: 768px) {
    margin-bottom: 16px;
  }
`

export const ItemHeading = styled.div<{ completed: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  font-weight: var(--font-bold);
  font-size: 16px;

  svg {
    color: var(--green);
    display: ${({ completed }) => (completed ? 'block' : 'none')};
  }
`

export const ItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 15px;
  font-weight: var(--font-regular);
  font-size: 16px;

  &.total-row {
    align-items: flex-end;
  }
`

export const Summary = styled.div`
  display: grid;
  grid-template-columns: 100%;
  gap: 20px;
  line-height: 1.3;
  width: 100%;

  .messages {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 20px;
    width: 100%;

    &:not(:last-child) {
      padding-bottom: 20px;
      border-bottom: 1px solid var(--grey-25);
    }

    > div {
      font-weight: var(--font-regular);

      &:nth-child(1),
      &:nth-child(2) {
        width: 20%;
      }
      &:nth-child(3) {
        width: 60%;
      }
    }
    span:first-child {
      display: block;
      line-height: 1;
      font-size: 14px;
      margin-bottom: 5px;
      font-weight: var(--font-medium);
    }
  }

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    gap: 20px;

    .messages {
      flex-direction: column;
      gap: 10px;

      > div {
        &:nth-child(1),
        &:nth-child(2),
        &:nth-child(3) {
          width: 100%;
        }
      }
    }
  }
`

export const Title = styled.span`
  display: block;
  font-weight: var(--font-bold);
  line-height: 1.4;
  font-size: 16px;
`

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-25%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const ItemWrapper = styled.div<{ active: boolean; skeleton?: boolean }>`
  padding: 35px;
  border: 1px solid ${({ active }) => (active ? 'var(--grey-100)' : 'var(--grey-25)')};
  border-radius: 12px;
  -webkit-tap-highlight-color: transparent;
  position: relative;
  background-color: white;

  ${({ skeleton }) =>
    !skeleton &&
    css`
      animation: ${fadeIn} 0.6s ease-in-out;
    `}

  ${OptionSelectorWrapper} {
    padding: 0;
  }

  &.disabled {
    pointer-events: none;
    opacity: 0.7;
  }

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    padding: 20px;
  }
`
export const Edit = styled.span`
  font-size: 14px;
  font-weight: var(--font-medium);
  text-decoration: underline;
  cursor: pointer;
`
